<script setup>
import { OnClickOutside } from '@vueuse/components';
// Emoji reactions
const emojis = [
  'emojis/Like',
  'emojis/Heart',
  'emojis/Haha',
  'emojis/Sad',
  'emojis/Wow',
  'emojis/Angry',
  'emojis/HeartEyes',
  'emojis/Fire',
  'emojis/FDancer',
  'emojis/MDancer',
  'emojis/Rose',
  'emojis/Wine',
];

const showEmojis = ref(Number(useInnerWidth()) < 99999);

async function reactionEffect($e) {
  const targetButton = $e.target.closest('button');
  const svg = targetButton.querySelector('svg').cloneNode(true);

  svg.classList.add(
    'block',
    'w-8',
    'h-8',
    'object-cover',
    'rounded-full',
    'absolute',
    'inset-0',
    'transition-all',
    'animate-el',
  );

  svg.addEventListener('animationend', (e) => {
    e.currentTarget.remove();
  });

  targetButton.append(svg);

  // Repeat the animation 5 times
  for (let i = 1; i <= 4; i++) {
    const clonedSvg = svg.cloneNode(true);
    clonedSvg.style.animationDelay = `${i * 0.1}s`;
    targetButton.append(clonedSvg);
  }
}
</script>

<template>
  <OnClickOutside @trigger="showEmojis = false">
    <template v-if="showEmojis">
      <button
        v-for="(emoji, index) in emojis"
        :key="index"
        type="button"
        class="emoji size-8"
        @click="reactionEffect"
      >
        <MoleculeNuxtIcon :name="emoji" :filled="true" />
      </button>
    </template>

    <button
      v-for="(emoji, index) in emojis"
      :key="index"
      type="button"
      class="emoji hidden size-8 md:block"
      @click="reactionEffect"
    >
      <MoleculeNuxtIcon :name="emoji" :filled="true" />
    </button>

    <button type="button" class="size-9 md:hidden">
      <MoleculeNuxtIcon
        name="ext"
        class="size-full"
        :filled="true"
        @click="showEmojis = !showEmojis"
      />
    </button>
  </OnClickOutside>
</template>

<style lang="scss">
@keyframes funnyAnimation {
  0% {
    opacity: 0;
    transform: translateY(-320px);
  }

  30% {
    opacity: 0;
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-el {
  animation: ease-out 1s reverse both running funnyAnimation;
}

@for $i from 1 through 13 {
  .emoji:nth-child(#{$i}n) {
    animation-delay: #{$i * 0.05}s;
  }
}

@keyframes FadeIn {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }

  85% {
    transform: translateY(-40%);
  }

  100% {
    opacity: 1;
    transform: translateY(0%);
  }
}
.emoji {
  animation: FadeIn 0.2s ease-in;
  animation-fill-mode: both;
}
</style>
